import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../api/axios";
import axios from "axios";
// TODO: install sockjs-client and @stomp/stompjs to re-enable
// import SockJS from "sockjs-client";
// import { Client } from "@stomp/stompjs";

const VivaChatWidget = ({ slot, role, title, index }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const senderId = localStorage.getItem("userId");
  const currentUsername = localStorage.getItem("username");
  const [client, setClient] = useState(null);

  const slotId = slot?.id;

  const [showNewMsg, setShowNewMsg] = useState(false);
  const messagesRef = useRef(null);
  const messagesEndRef = useRef(null);

  const [unreadCount, setUnreadCount] = useState(0);

  const [seenMap, setSeenMap] = useState({});

  useEffect(() => {
    if (isOpen && slotId) {
      fetchMessages();
    }
  }, [isOpen, slotId]);

  useEffect(() => {
    if (!isOpen || !messages.length || !senderId) return;

    messages.forEach(msg => {

    if (Number(msg.senderId) !== Number(senderId)) {

      axiosInstance.post("/chat/seen", null, {
        params: {
          slotId: slot.id,
          userId: senderId,
          messageId: msg.id,
          username: currentUsername
        }
      });

    }
  });

  }, [messages, isOpen, senderId]);

  // TODO: uncomment when sockjs-client and @stomp/stompjs are installed
  // useEffect(() => {
  //   if (!slotId) return;
  //   const socket = new SockJS("http://localhost:8089/stmmgmt/ws-chat");
  //   const stompClient = new Client({
  //     webSocketFactory: () => socket,
  //     reconnectDelay: 5000,
  //     onConnect: () => {
  //       stompClient.subscribe(`/topic/slot/${slotId}`, (msg) => {
  //         const newMessage = JSON.parse(msg.body);
  //         setMessages(prev => [...prev, newMessage]);
  //         if (!isOpenRef.current && Number(newMessage.senderId) !== Number(senderId)) {
  //           setUnreadCount(prev => prev + 1);
  //         }
  //       });
  //       stompClient.subscribe(`/topic/seen/${slot.id}`, (msg) => {
  //         const data = JSON.parse(msg.body);
  //         setSeenMap(prev => {
  //           const existing = prev[data.messageId] || [];
  //           const alreadyExists = existing.some(u => Number(u.userId) === Number(data.userId));
  //           if (alreadyExists) return prev;
  //           return { ...prev, [data.messageId]: [...existing, { userId: data.userId, username: data.username }] };
  //         });
  //       });
  //     }
  //   });
  //   stompClient.activate();
  //   setClient(stompClient);
  //   return () => { stompClient.deactivate(); };
  // }, [slotId]);

  const fetchMessages = async () => {
    try {
      const res = await axiosInstance(`/chat/${slotId}`);
      const data = res.data;

      setMessages(data.data || []);

    } catch (err) {
      console.error(err);
    }
  };

  const toggleChat = () => {
    setIsOpen(prev => {
      const newState = !prev;

      if (!prev) {
        setUnreadCount(0);
      }

      return newState;
    });
  };

  const sendMessage = async () => {
    if (!input.trim()) return;

    const payload = {
      slotId: slot.id,
      senderId: senderId,
      senderName: currentUsername,
      role: role,
      message: input
    };

    try {
      const res = await axiosInstance.post("/chat/send", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = res.data;

      setInput("");

    } catch (err) {
      console.error(err);
    }
  };

  const isNearBottom = () => {
    const container = messagesRef.current;
    if (!container) return true;

    return (
      container.scrollHeight - container.scrollTop - container.clientHeight < 100
    );
  };

  useEffect(() => {
    const container = messagesRef.current;

    if (!container) return;

    const nearBottom =
      container.scrollHeight -
        container.scrollTop -
        container.clientHeight <
      120;

    if (nearBottom) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({
          behavior: "smooth"
        });
      }, 100);

      setShowNewMsg(false);
    } else {
      setShowNewMsg(true);
    }

  }, [messages]);

  useEffect(() => {
    const container = messagesRef.current;

    if (!container) return;

    const handleScroll = () => {
      const nearBottom =
        container.scrollHeight -
          container.scrollTop -
          container.clientHeight <
        120;

      if (nearBottom) {
        setShowNewMsg(false);
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };

  }, []);

  const isOpenRef = useRef(isOpen);

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  const styles = {
    container: {
      position: "fixed",
      bottom: "20px",
      right: `${20 + index * 340}px`,
      width: "320px",
      zIndex: 9999,
    },
    header: {
      background: "#0d6efd",
      color: "#fff",
      padding: "10px",
      cursor: "pointer",
      borderRadius: "8px 8px 0 0",
      display: "flex",
      justifyContent: "space-between",
      position:"relative"
    },
    chatBox: {
      position:"relative",
      background: "#fff",
      border: "1px solid #ccc",
      height: "380px",
      display: "flex",
      flexDirection: "column"
    },
    statusBar: {
      display: "flex",
      gap: "5px",
      padding: "8px",
      borderBottom: "1px solid #eee",
      flexWrap: "wrap"
    },
    statusBtn: {
      padding: "5px 8px",
      border: "none",
      cursor: "pointer",
      borderRadius: "5px"
    },
    adminBar: {
      padding: "8px",
      borderBottom: "1px solid #eee"
    },
    messages: {
      flex: 1,
      padding: "10px",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    message: {
      padding: "8px 12px",
      borderRadius: "12px",
      maxWidth: "75%"
    },
    inputContainer: {
      display: "flex",
      borderTop: "1px solid #ccc"
    },
    input: {
      flex: 1,
      padding: "8px",
      border: "none"
    },
    button: {
      padding: "8px 10px",
      border: "none",
      background: "#0d6efd",
      color: "#fff",
      cursor: "pointer"
    }
  };

  return (
    <div style={styles.container}>

      <div className="chat-header" style={styles.header} onClick={toggleChat}>
        {title || `Viva Panel ${role} `}
        <br />
        {slot?.date} | {slot?.startTime} - {slot?.endTime}
        <br />
        <div>
          {slot?.students?.length > 0 ? (
            slot.students.map((s, i) => (
              <div key={i}>
                {s.student_name} ({s.enrollment_number})
              </div>
            ))
            ) : (
              <div style={{ fontSize: "12px", opacity: 0.7 }}>
                No student data
              </div>
          )}
        </div>
        {unreadCount > 0 && (
          <span
            style={{
              background: "red",
              color: "#fff",
              borderRadius: "50%",
              minWidth: "16px",
              height: "16px",
              fontSize: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              top: "6px",
              right: "28px", 
            }}
          >
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
        <span>{isOpen ? "▼" : "▲"}</span>
      </div>

      {isOpen && (
        <div style={styles.chatBox}>

          <div style={styles.messages} ref={messagesRef}>
            {messages.map((msg, index) => {
              const isMe = Number(msg.senderId) === Number(senderId);

              const seenUsers =
                (seenMap[msg.id] || []).filter(
                  u => Number(u.userId) !== Number(senderId)
                );

              return (
                <div
                  key={index}
                  style={{
                    ...styles.message,
                    alignSelf: isMe ? "flex-end" : "flex-start",
                    background: isMe ? "#d1e7dd" : "#f1f1f1"
                  }}
                >
                  <strong style={{ fontSize: "12px" }}>
                    {isMe ? "You" : msg.senderName}
                  </strong>

                  <div>{msg.message}</div>

                  <small style={{ fontSize: "10px", color: "#666" }}>
                    {msg.timestamp
                      ? new Date(msg.timestamp).toLocaleTimeString()
                      : ""}
                  </small>
                  {isMe && (
                    <small style={{ fontSize: "10px", color: "#666" }}>
                      {seenUsers.length > 0
                        ? `Seen by ${seenUsers.map(u => u.username).join(", ")}`
                        : "Sent"}
                    </small>
                  )}
                </div>
              );
            })}
            <div ref={messagesEndRef} />
          </div>

          {showNewMsg && (
            <div
              onClick={() => {
                messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
                setShowNewMsg(false);
              }}
              style={{
                position: "absolute",
                bottom: "60px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "#0d6efd",
                color: "#fff",
                padding: "6px 12px",
                borderRadius: "20px",
                cursor: "pointer",
                fontSize: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
              }}
            >
              ⬇️ Jump to Latest
            </div>
          )}

          {/* INPUT (Student + Others can send text) */}
          <div style={styles.inputContainer}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              style={styles.input}
              placeholder="Type a message..."
            />
            <button onClick={sendMessage} style={styles.button}>
              Send
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default VivaChatWidget;